<template lang="pug">
  v-menu( transition="scale-transition" offset-y width="400px" min-width="auto")
    template(v-slot:activator="{ on, attrs }")
      v-text-field.datePicker(v-model="inputValue"
        v-mask="'####-##-##'"
        :label="label"
        prepend-icon="mdi-calendar"
        :rules="docDate ? '' : dateRules"
        required
        :disabled="disabled"
        v-bind="attrs"
        v-on="on")
</template>

<script>
export default {
  props: ['value', 'label', 'errors', 'desc', 'disabled', 'docDate'],

  data: function() {
    return {
      inputValue: this.formatvalue(),
      error: '',
      outActive: true,
      dateRules: [
        v => /^\d{4}-\d{2}-\d{2}$/.test(v) || 'Формат даты: гггг-мм-дд',
        v => this.isValidDate(v) || 'Некорректная дата',
      ],
    }
  },

  model: {
    prop: 'value',
    event: 'input'
  },

  watch: {
    inputValue(val) {
      this.changeInput(val)
    }
  },

  computed: {
    valid() {
      return /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(this.inputValue) ? true : false
    },
  },

  methods: {

    isValidDate(dateString) {
      const [year, month, day] = dateString.split('-').map(Number)
      const date = new Date(year, month - 1, day)
      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      )
    },
		changeInput(val) {
      this.$emit('input', val)
    },

    changeDate(val) {
      this.inputValue = this.format(val);
    },

    formatvalue() {
      return this.format(this.value)
    },
    
    format(val) {
      let date = Date.parse(val);
      if (isNaN(date)) return ''
      date = new Date(date)
      return isNaN(date) ? '' : `${date.getFullYear()}-${(date.getMonth() + 1 + '').padStart(2, "0")}-${('' + date.getDate()).padStart(2, "0")}`;
    }
  }
}
</script>
<style scoped>
.datePicker{
  width: 400px !important;
}
</style>